module.exports = __webpack_public_path__ + "static/media/night_top.d198de18.jpg";